document.addEventListener("DOMContentLoaded", function () {
	const floatingFooters = document.querySelectorAll(".bds-tray");

	if (floatingFooters.length) {
		floatingFooters.forEach(function (floatingFooter) {
			let lastKnownScrollPosition = 0;

			window.addEventListener("scroll", function() {
				const viewportHeight = window.innerHeight;
				const documentHeight = document.documentElement.scrollHeight;

				lastKnownScrollPosition = window.scrollY;

				let distanceFromBottom =
					documentHeight - (lastKnownScrollPosition + viewportHeight);

				if (0 >= distanceFromBottom) {
					floatingFooter.classList.add("at-bottom");
				} else {
					floatingFooter.classList.remove("at-bottom");
				}
			});
		});
	}
});
